import type { FC, SVGProps } from 'react';

export const LikeIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9043_31915)">
        <path
          fill="currentColor"
          d="M14.6771 8.38707C14.9771 7.99064 15.1431 7.50492 15.1431 6.99957C15.1431 6.19778 14.6949 5.43885 13.9735 5.01564C13.7878 4.9067 13.5763 4.84937 13.361 4.84957H9.07885L9.186 2.65492C9.21099 2.12457 9.02349 1.621 8.65921 1.23707C8.48043 1.04783 8.26475 0.897269 8.02549 0.794683C7.78622 0.692098 7.52846 0.63967 7.26814 0.640638C6.33957 0.640638 5.51814 1.26564 5.27171 2.16028L3.73778 7.71385H1.42885C1.11278 7.71385 0.857422 7.96921 0.857422 8.28528V14.7853C0.857422 15.1014 1.11278 15.3567 1.42885 15.3567H12.1664C12.3306 15.3567 12.4914 15.3246 12.6396 15.2603C13.4896 14.8978 14.0378 14.0674 14.0378 13.146C14.0378 12.921 14.0056 12.6996 13.9414 12.4853C14.2414 12.0889 14.4074 11.6031 14.4074 11.0978C14.4074 10.8728 14.3753 10.6514 14.311 10.4371C14.611 10.0406 14.7771 9.55492 14.7771 9.04957C14.7735 8.82457 14.7414 8.60135 14.6771 8.38707ZM2.14314 14.071V8.99957H3.58957V14.071H2.14314ZM13.5074 7.76742L13.1164 8.10671L13.3646 8.56028C13.4463 8.70969 13.4887 8.87746 13.4878 9.04778C13.4878 9.34242 13.3592 9.62278 13.1378 9.81564L12.7467 10.1549L12.9949 10.6085C13.0767 10.7579 13.1191 10.9257 13.1181 11.096C13.1181 11.3906 12.9896 11.671 12.7681 11.8639L12.3771 12.2031L12.6253 12.6567C12.7071 12.8061 12.7495 12.9739 12.7485 13.1442C12.7485 13.5442 12.5128 13.9049 12.1485 14.0692H4.73242V8.94242L6.50921 2.50492C6.55502 2.33992 6.65338 2.19436 6.78936 2.09027C6.92534 1.98619 7.09154 1.92927 7.26278 1.92814C7.39849 1.92814 7.53242 1.96742 7.63957 2.04778C7.81635 2.17992 7.91099 2.37992 7.90028 2.59242L7.72885 6.13528H13.3431C13.661 6.32992 13.8574 6.6585 13.8574 6.99957C13.8574 7.29421 13.7289 7.57278 13.5074 7.76742Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_9043_31915">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
